import ReactECharts from 'echarts-for-react';
import { useMemo } from 'react';

import { clamp } from '../../shared/utils/stat-helpers';

interface PsiGaugeProps {
  value: number;
  height?: string;
}

export function PsiGauge({ value, height = '80px' }: PsiGaugeProps) {
  const option = useMemo(
    () => ({
      series: [
        {
          type: 'gauge',
          startAngle: 210,
          endAngle: -30,
          min: 0,
          max: 100,
          splitNumber: 5,
          progress: { show: true, width: 10 },
          axisLine: { lineStyle: { width: 10 } },
          axisTick: { show: false },
          splitLine: { show: false, length: 10 },
          axisLabel: { show: false },
          pointer: { show: true, width: 4 },
          detail: { valueAnimation: true, formatter: '{value}', fontSize: 1 },
          data: [{ value: clamp(value, 0, 100) }],
        },
      ],
    }),
    [value],
  );

  return (
    <div style={{ height }}>
      <ReactECharts option={option} style={{ height: '100%' }} />
    </div>
  );
}
